import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Overlay } from 'react-overlays';
import BorderedTooltip from '../bordered-tooltip';
import withSettingsColor from '../../hoc/with-settings-color';
import { CARD_BACKGROUND_COLOR_PATH, APP_TEXT_COLOR_PATH } from '../../constants/wix-params';

class IconTooltip extends Component {

  state = {
    isTooltipVisible: false,
  };

  componentWillUnmount() {
    this.handleMouseLeave();
  }

  handleMouseEnter = () => {
    this.timeout = setTimeout(() => {
      this.setState({
        isTooltipVisible: true,
      });
    }, 500);
  };

  handleMouseLeave = () => {
    clearTimeout(this.timeout);
    this.setState({
      isTooltipVisible: false,
    });
  };

  render() {
    const { children, text, backgroundColor, borderColor, className } = this.props;
    const tooltipClassName = classNames('forum-content-medium-font', 'forum-text-color');
    const tooltipStyle = { borderColor, backgroundColor, fontSize: 12 };
    return (
      <div
        className={className}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {children}
        <Overlay
          show={this.state.isTooltipVisible}
          placement="top"
          target={this}
        >
          <BorderedTooltip className={tooltipClassName} style={tooltipStyle}>
            {text}
          </BorderedTooltip>
        </Overlay>
      </div>);
  }
}

IconTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default flowRight(
  withSettingsColor(CARD_BACKGROUND_COLOR_PATH, 'backgroundColor', 'color-1', 1),
  withSettingsColor(APP_TEXT_COLOR_PATH, 'borderColor', 'color-5', 0.2),
)(IconTooltip);



// WEBPACK FOOTER //
// ./app/components/icon-tooltip/icon-tooltip.js